import React from 'react';
import { useFeatureFlagContext } from '../providers/FeatureFlagProvider';

/**
 * FeatureFlagGate — UX only.
 * Backend enforcement remains authoritative.
 * Avoids flash: when loading, renders fallback or nothing (not disabled UI).
 * When flag disabled, renders fallback (or null).
 * @param {string} flag — FeatureFlagName
 * @param {React.ReactNode} fallback — shown when disabled
 * @param {React.ReactNode} loadingFallback — shown when loading (null avoids flash)
 */
export const FeatureFlagGate = ({ flag, children, fallback = null, loadingFallback = null }) => {
    const { isEnabled, loading } = useFeatureFlagContext();

    if (loading) {
        return loadingFallback;
    }

    if (!isEnabled(flag)) {
        return fallback;
    }

    return <>{children}</>;
};

export default FeatureFlagGate;
